var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57771 15.2283C8.20417 17.3346 5.90252 20 2.8399 20C1.39211 20 0 19.4035 0 16.8127C0 10.2143 9.00228 0 17.355 0C22.1067 0 24 3.29917 24 7.04565C24 11.8546 20.8816 17.3532 17.7818 17.3532C16.7981 17.3532 16.3155 16.8127 16.3155 15.9553C16.3155 15.7316 16.3526 15.4893 16.4269 15.2283C15.3689 17.0363 13.3271 18.7139 11.4153 18.7139C10.0232 18.7139 9.31785 17.8378 9.31785 16.6076C9.31785 16.1603 9.41064 15.6943 9.57771 15.2283ZM16.7729 6.9156C16.7729 8.00731 16.1292 8.55317 15.4092 8.55317C14.6783 8.55317 14.0456 8.00731 14.0456 6.9156C14.0456 5.82392 14.6783 5.27806 15.4092 5.27806C16.1292 5.27806 16.7729 5.82392 16.7729 6.9156ZM20.8638 6.91563C20.8638 8.00731 20.2201 8.55317 19.5001 8.55317C18.7692 8.55317 18.1365 8.00731 18.1365 6.91563C18.1365 5.82392 18.7692 5.27806 19.5001 5.27806C20.2201 5.27806 20.8638 5.82392 20.8638 6.91563Z",
    fill: "#AB9FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.4c2697661c760b64aa4a290611d9a618.svg";
export { ForwardRef as ReactComponent };